<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="900px" class="dialog" title="我的运单" :close-on-click-modal="false">
      <div>

        <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="loading">
          <el-radio-group v-model="queryPamars.orderStatus" @change="stateChange" v-show="activeName == 'first'">
            <el-radio-button label="0">进行中</el-radio-button>
            <el-radio-button label="1">已签收</el-radio-button>
            <el-radio-button label="2">已取消</el-radio-button>
          </el-radio-group>
          <el-tab-pane label="我寄出的" name="first" style="background: #F5F7F8;overflow:auto;height: 600px;">
            <div class="list" v-if="isLoadState">
              <div class="item" v-for="(item, index) in dataList" :key="index">
                <div class="item_code">运单号:{{ item.orderNo }}</div>
                <div class="item_open" v-if="queryPamars.orderStatus != 2" @click="setExpressSheet(item)">生成面单</div>
                <div class="item_row">
                  <div class="item_row_left">
                    <div class="item_row_title">{{ item.senderAreaSpan }}</div>
                    <div class="item_row_name">{{ item.senderName }}</div>
                  </div>
                  <div class="item_row_mid"><img :src="require('@/assets/icon/new_in_transit.png')" alt=""></div>
                  <div class="item_row_right">
                    <div class="item_row_title">{{ item.receiverAreaSpan }}</div>
                    <div class="item_row_name">{{ item.receiverName }}</div>
                  </div>
                </div>
                <div class="item_list" @click="openDetail(item, index)">
                  <div class="item_state">
                    <img :src="require('@/assets/icon/time_line.png')" alt="">
                    <div class="item_state_content">
                      <div class="item_state_content_title">{{ item.statusSpan }}</div>
                      <div class="item_state_content_time">{{ item.createTimeSpan }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="not_data">
              <img :src="require('@/assets/icon/noData.png')" alt="">
              <div>暂无内容</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="我收到的" name="second" style="background: #F5F7F8;overflow:auto;height: 600px;">
            <div class="list" v-if="isLoadState">
              <div class="item" v-for="(item, index) in dataList" :key="index" @click="openDetail(item, index)">
                <div class="item_code">运单号:{{ item.orderNo }}</div>
                <div class="item_row">
                  <div class="item_row_left">
                    <div class="item_row_title">{{ item.senderAreaSpan }}</div>
                    <div class="item_row_name">{{ item.senderName }}</div>
                  </div>
                  <div class="item_row_mid"><img :src="require('@/assets/icon/new_in_transit.png')" alt=""></div>
                  <div class="item_row_right">
                    <div class="item_row_title">{{ item.receiverAreaSpan }}</div>
                    <div class="item_row_name">{{ item.receiverName }}</div>
                  </div>
                </div>
                <div class="item_list">
                  <div class="item_state">
                    <img :src="require('@/assets/icon/time_line.png')" alt="">
                    <div class="item_state_content">
                      <div class="item_state_content_title">{{ item.statusSpan }}</div>
                      <div class="item_state_content_time">{{ item.createTimeSpan }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="not_data">
              <img :src="require('@/assets/icon/noData.png')" alt="">
              <div>暂无内容</div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div style="text-align: right;padding-top: 10px;" v-if="total > 0">
          <el-pagination background :page-size="queryPamars.pageSize" :page-count="queryPamars.pageNum"
            layout="prev, pager, next" :total="total" @current-change="pageChange">
          </el-pagination>
        </div>

      </div>
    </el-dialog>
    <el-dialog title="运单详情" :destroy-on-close="true" :visible.sync="searchVisible" width="800px">
      <div>
        <div class="detail_content">
          <div class="detail_content_code">快件单号：{{ orderDetail?.orderNo }}</div>
          <div class="detail_content_list" v-for="(item,index) in orderDetail.details" :key="index">
            <div class="detail_content_item">
              <img :src="require('@/assets/icon/time_line.png')" alt="">
              <div class="detail_content_item_box">
                <div class="detail_content_state">{{item.statusSpan}}</div>
                <div class="detail_content_time">{{item.createTimeSpan}}</div>
                <div class="detail_content_status">{{item.content ? item.content : ''}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <ExpressSheet ref="expressSheet" :visible="expressSheetVisible" @close="closeExpressSheet" />
  </div>
</template>

<script>
import { orderPage, search } from '@/api/home.js'
import ExpressSheet from './expressSheet.vue'
export default {
  components:{ExpressSheet},
  data() {
    return {
      dialogVisible: false,
      activeName: 'first',
      queryPamars: {
        dataType: 0,
        orderStatus: 0,
        pageNum: 1,
        pageSize: 5
      },
      dataList: [],
      total: 0,
      loading: false,
      isLoadState: true,
      searchVisible: false,
      orderDetail:{},
      expressSheetVisible:false
    }
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.init();
    },
    close() {
      this.dialogVisible = false;
    },
    handleClick(tab, event) {
      this.queryPamars.dataType = this.activeName == 'first' ? 0 : 1;
      this.init();
    },
    init() {
      this.loading = true;
      orderPage(this.queryPamars).then(response => {
        this.loading = false;
        if (response.total == 0) {
          this.isLoadState = false;
        }
        this.dataList = response.rows;
        this.total = response.total;
      })
    },
    stateChange(e) {
      this.isLoadState = true;
      this.queryPamars.orderStatus = e;
      this.init();
    },
    pageChange(e) {
      this.queryPamars.pageNum = e;
      this.init();
    },
    openDetail(val) {
      console.log(val);
      search({}, val.orderNo).then(response => {
        if (response.code == 200) {
          this.orderDetail = response.data;
          this.searchVisible = true;
        }
      })
    },
    setExpressSheet(val){
      this.expressSheetVisible = true;
      this.$nextTick(() => {
        this.$refs.expressSheet.setData(val)
      })
    },
    closeExpressSheet(){
      this.expressSheetVisible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.list {
  width: 710px;
  margin: 0 auto;
  margin-top: 20px;

  .item {
    width: 690rpx;
    margin: 0 auto;
    background: #fff;
    margin-bottom: 20px;
    box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: .1);
    border-radius: 12px;
    box-sizing: border-box;
    padding: 27px 24px;
    position: relative;
    .item_open{
      font-size: 24px;
      color: #2C8EF4;
      position: absolute;
      right: 24px;
      top: 27px;
      z-index: 100;
      user-select: none;
      cursor: pointer;
    }
    .item_code {
      font-weight: 400;
      font-size: 24px;
      color: #535C7D;
      margin-bottom: 25px;
    }

    .item_row {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-bottom: 30px;
    }

    .item_row_left {
      width: 200px;
      flex-shrink: 0;
    }

    .item_row_right {
      width: 200px;
      flex-shrink: 0;
    }

    .item_row_mid {
      width: 199px;
      height: 73px;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .item_row_title {
      width: 200px;
      text-align: center;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
    }

    .item_row_name {
      color: #666666;
      font-size: 24px;
      font-weight: 400;
      text-align: center;
    }

    .item_list {
      width: 642px;
      height: 142px;
      background: rgba(2, 129, 254, 0.05);
      border-radius: 12px;
      box-sizing: border-box;
      padding: 30px 27px;

      .item_state {
        display: flex;

        img {
          width: 23px;
          height: 74px;
          margin-right: 10px;
          flex-shrink: 0;
        }

        .item_state_content_title {
          font-size: 32px;
          color: #333;
          font-weight: 500;
          margin-bottom: 6px;
        }

        .item_state_content_time {
          font-size: 24px;
          color: #666;
        }
      }
    }
  }
}

.not_data {
  padding: 40px 0;

  img {
    width: 396px;
    height: 350px;
    margin-bottom: 40px;
  }

  text-align: center;
  font-size: 26rpx;
  color: #999;
}

.detail_content {
  padding: 27px 20px;
  border-radius: 20px;
  background-color: rgba(2, 129, 254, 0.05);

  .detail_content_code {
    font-size: 24px;
    color: #535C7D;
    font-weight: 400;
    margin-bottom: 25px;
  }

  .detail_content_item {
    display: flex;
    position: relative;
    font-size: 24px;
    color: #333333;
    position: relative;
    box-sizing: border-box;
    padding-left: 50px;
    margin-bottom: 30px;

    img {
      width: 23px;
      height: 74px;
      position: absolute;
      left: 0;
      top: 0;
    }

    .detail_content_state {
      font-size: 32px;
      color: #333;
      font-weight: 500;
    }

    .detail_content_time {
      font-size: 24px;
      color: #666;
      margin-block: 18px;
    }

    .detail_content_status {}
  }
}
</style>